/**
 * @type {Object}
 * @property {array}  data  Product data
 */
const initialState = {
    productsData: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerProduct = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_PRODUCTS_DATA':
            var { data } = action;
            newState.productsData = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerProduct;